import React from 'react';
import {connect} from 'react-redux';
import {StackedPlayerAnalyzerFactory} from 'components/organisms/lineup/components/stacked-player-analyzer-factory';
import TeamLogo from 'components/molecules/team-logo';
import Const from 'constants';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';
import PlayerInjury from 'components/molecules/player-injury';

class LineupPlayersComponent extends BaseLineupPlayers {
    constructor(props) {
        super(props);
        this.stackPlayerAnalyzer = StackedPlayerAnalyzerFactory.createAnalyzer(
            {
                sport: Const.LEAGUE_NFL,
            },
            props,
        );
    }
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        if (!lineup) {
            return null;
        }

        const rows = lineup.players.map((player) => {
            return (
                <tr key={player.playerId} className={this.getRowClassName(player)}>
                    <td>
                        <strong className={this.getStackClassName(player)}>{player.name}</strong>
                        <PlayerInjury player={player} />
                    </td>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <TeamLogo teamName={player.team.toUpperCase()} />
                    </td>
                    <td>
                        <strong className="text-gray">{player.salary}</strong>/{this.getPlayerPointsView(player)}
                    </td>
                </tr>
            );
        });

        return (
            <table className="table">
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {
        correlationStacking,
        playerPositionStacking,
        stacks: {groups},
        runSettings,
        lineupsData: {lineups, rawLineups},
        filterLineupsByPlayer,
        playersData: {players},
    } = state;

    return {
        players,
        lineups,
        rawLineups,
        correlationStacking,
        playerPositionStacking,
        keyPlayerStackingGroupsStateId: groups.getStateId(),
        runSettings,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
